import Vue from "vue"
import Vuetify from "vuetify/lib"

import App from "./App.vue"
import store from './store/store.js'
import i18n from './i18n/i18n.js'

import 'jquery-ui-sortable'
import 'html2canvas'

import '../css/root.scss'
import '../../static/images/svg/fontello/css/fontello.css'

Vue.use(Vuetify)

Vue.directive('focus', {
    inserted: function(el) {
        el.focus()
    }
})

Vue.directive('draggable', {
    bind: function (el) {
        $(el).draggable({
            containment: 'parent',
        })
    }
})

import {check_logged_state_ajax} from './utils/login.js'

const opts = {
    theme: {
        dark: false,
    },
    iconfont: 'fontello',
} 

new Vue({
    vuetify: new Vuetify(opts),
    el: '#app',
    i18n,
    store,
    components:{'App': App},
    created() {
        this.checkLogin();
    },
    methods: {
        checkLogin(){
            check_logged_state_ajax.call(this);
        }
    }    
})



